import React from 'react';
import { Stack } from '@mui/material';
import { ArrowRightAlt } from '@mui/icons-material';

import { DealerListChanges } from '../../../../types';
import { NamedEntityList } from './NamedEntityList';

interface DealerListRenderProps {
  changes: DealerListChanges;
}

export const DealerListRender = ({ changes }: DealerListRenderProps) => (
  <Stack direction="row" alignItems="center" gap="0.5rem">
    <NamedEntityList items={changes.partnerLinkIds.before} />

    <ArrowRightAlt />

    <NamedEntityList items={changes.partnerLinkIds.after} />
  </Stack>
);
